import React, { useState } from 'react';
import PropTypes from 'prop-types';
import * as classes from './SignupForm.module.css';
import Button from '../button/Button';
import { API_PATH } from '../../utils/constants'

const SignupForm = ({
  title,
  formField,
  buttonText,
  disclaimer,
  mailingLists,
  returnMessage,
}) => {
  const fieldInfo = formField.references[0];
  const [inputValue, setInputValue] = useState('');
  const [subscriptionSent, setSubscriptionSent] = useState(false);

  const handleFieldChange = (ev) => {
    setInputValue(ev.target.value);
  };

  const onSubmit = (ev) => {
    ev.preventDefault();

    const year = new Date().getFullYear();
    let month = new Date().getMonth() + 1;
    let day = new Date().getDate();
    if (month.length < 2) {
      month = '0' + month;
    }
    if (day.length < 2) {
      day = '0' + day;
    }

    let country;
    const getCountryCode = async () => {
      const response = await fetch(`${API_PATH}/region`, { method: 'get' });
      const countryToken = response.json();
      return countryToken;
    };
    getCountryCode().then((result) => {
      const token = result.token.split('.');
      country = JSON.parse(window.atob(token[1]));
    });

    const klaviyoData = {
      email: inputValue,
      mailing_lists: mailingLists,
      country: country.countryCode,
    };

    const submitKlaviyoData = async () => {
      await fetch(`${API_PATH}/mailing-lists`, {
        method: 'post',
        body: JSON.stringify(klaviyoData),
      });
    };
    submitKlaviyoData();
    setSubscriptionSent(true);
  };

  return subscriptionSent ? (
    <div className={classes.subscriptionSent}>
      <h3>{returnMessage}</h3>
    </div>
  ) : (
    <form className={classes.signupForm} onSubmit={onSubmit}>
      <h3>{title}</h3>
      <div className={classes.content}>
        <input
          type="text"
          className={classes.signupInput}
          name={fieldInfo.name}
          placeholder={fieldInfo.placeholderText}
          required={fieldInfo.required}
          value={inputValue}
          onChange={handleFieldChange}
        />
        <Button signupForm>{buttonText}</Button>
      </div>
      <p>{disclaimer && disclaimer}</p>
    </form>
  );
};

SignupForm.propTypes = {
  title: PropTypes.string.isRequired,
  formField: PropTypes.object.isRequired,
  buttonText: PropTypes.string.isRequired,
  disclaimer: PropTypes.string,
  mailingLists: PropTypes.array.isRequired,
  returnMessage: PropTypes.string.isRequired,
};

export default SignupForm;
